<template>
    <div class="query-container">
        <span class="search-icon">
            <cp-icon name="search"></cp-icon>
        </span>

        <input
            type="text"
            class="query-input"
            :name="name"
            v-model="query"
            placeholder="Search CrowdBlue"
            autocomplete="off"
            @input="handleInput"
        />

        <button type="submit" v-if="query" class="search-arrow">
            <cp-icon name="arrow-right"></cp-icon>
        </button>
    </div>
</template>

<script>
import CpIcon from '../../icon';

export default {
    components: {
        CpIcon,
    },

    props: {
        value: String,
        name: String,
        debounce: { type: Number, default: 250 },
    },

    data() {
        return {
            query: this.value,
            debounceTimeout: NaN,
        };
    },

    methods: {
        handleInput(event) {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => {
                this.$emit('input', this.query);
            }, this.debounce);
        },
    },
};
</script>

<style scoped>
.query-container {
    line-height: 1.2;
    position: relative;
}

.search-icon {
    font-size: 18px;
    left: 12px;
    opacity: 0.7;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: var(--primary-1);
}

.query-input {
    border: 0;
    box-shadow: none;
    box-sizing: border-box;
    display: block;
    font: inherit;
    height: auto;
    line-height: inherit;
    margin: 0;
    padding: 13px 30px 11px 35px;
    width: 100%;
    height: 38px;;
}

.query-input:focus {
    border: 0;
    box-shadow: none;
    outline: none !important;
}
.site-header .inline-button:focus,
.site-header i:focus {
    outline: none !important;
}

.search-arrow {
    background: transparent;
    border: 0;
    color: var(--primary);
    font: inherit;
    position: absolute;
    right: calc(1.3vw + 2px);
    top: 50%;
    transform: translateY(-50%);
}
</style>
